import { apiGET } from './api';

export const getDonationSizes = () => apiGET('/donation_sizes');
